import { Box, Button, Tooltip, Typography } from '@mui/material'
import { ContentCopy } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

interface ErrorTooltipProps {
  error: string
}

export const ErrorTooltip = ({ error }: ErrorTooltipProps) => {
  const { t } = useTranslation()

  return (
    <Tooltip
      arrow
      title={
        <Box sx={{ p: 0.5 }}>
          <Typography variant="body2" sx={{ mb: 1, whiteSpace: 'pre-wrap' }}>
            {error}
          </Typography>
          <Button
            size="small"
            startIcon={<ContentCopy />}
            onClick={() => navigator.clipboard.writeText(error)}
            sx={{ color: 'inherit' }}
          >
            {t('common.copy')}
          </Button>
        </Box>
      }
      slotProps={{
        tooltip: { sx: { maxWidth: 500 } },
      }}
    >
      <Typography
        component="span"
        sx={{ color: 'error.main', fontWeight: 600, cursor: 'pointer' }}
      >
        {t('common.error')}
      </Typography>
    </Tooltip>
  )
}
